// Dawn theme Slider Functionality with Custom Scrollbar - iOS Fixed
function initializeSliders() {
  const sliders = document.querySelectorAll('.product-features-slider--active [data-slider]');
  
  sliders.forEach(slider => {
    if (slider.hasAttribute('data-slider-initialized')) return;
    slider.setAttribute('data-slider-initialized', 'true');
    
    const container = slider.querySelector('[data-slider-container]');
    const track = slider.querySelector('[data-slider-track]');
    const prevBtn = slider.querySelector('[data-slider-prev]');
    const nextBtn = slider.querySelector('[data-slider-next]');
    const items = track?.querySelectorAll('.slider-item');
    
    if (!container || !track || !prevBtn || !nextBtn || !items || items.length === 0) return;
    
    let currentScroll = container.scrollLeft;
    
    initCustomScrollbar(slider, container);
    
    function getScrollAmount() {
      const firstItem = items[0];
      if (!firstItem) return container.offsetWidth * 0.5;
      const itemWidth = firstItem.offsetWidth;
      const computedStyle = window.getComputedStyle(track);
      const gap = parseFloat(computedStyle.gap) || 0;
      return itemWidth + gap;
    }
    
    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - container.offsetWidth);
    }
    
    function updateButtons() {
      currentScroll = container.scrollLeft;
      const maxScroll = getMaxScroll();
      const isAtStart = currentScroll <= 1;
      const isAtEnd = currentScroll >= maxScroll - 1;
      prevBtn.style.opacity = isAtStart ? '0' : '1';
      nextBtn.style.opacity = isAtEnd ? '0' : '1';
      prevBtn.disabled = isAtStart;
      nextBtn.disabled = isAtEnd;
    }
    
    function scrollTo(position) {
      const maxScroll = getMaxScroll();
      currentScroll = Math.max(0, Math.min(position, maxScroll));
      container.scrollTo({ left: currentScroll, behavior: 'smooth' });
      updateButtons();
    }
    
    prevBtn.addEventListener('click', () => {
      scrollTo(currentScroll - getScrollAmount());
    });
    
    nextBtn.addEventListener('click', () => {
      scrollTo(currentScroll + getScrollAmount());
    });
    
    container.addEventListener('scroll', () => {
      currentScroll = container.scrollLeft;
      updateButtons();
    });
    
    setTimeout(() => {
      currentScroll = container.scrollLeft;
      updateButtons();
    }, 100);
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        currentScroll = container.scrollLeft;
        const maxScroll = getMaxScroll();
        if (currentScroll > maxScroll) {
          container.scrollLeft = maxScroll;
          currentScroll = maxScroll;
        }
        updateButtons();
      }, 250);
    });
  });
}

function initCustomScrollbar(wrapper, slider) {
  const scrollbar = wrapper.querySelector('.custom-scrollbar-track');
  const thumb = scrollbar?.querySelector('.custom-scrollbar-thumb');
  if (!scrollbar || !thumb) return;
  setupScrollbar(slider, scrollbar, thumb);
}

function setupScrollbar(slider, scrollbar, thumb) {
  let dragging = false;
  let startX, startScroll;
  
  function update() {
    const percent = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
    const thumbWidth = (slider.clientWidth / slider.scrollWidth) * 100;
    thumb.style.width = thumbWidth + '%';
    thumb.style.left = (percent * (100 - thumbWidth)) + '%';
    if (slider.scrollWidth > slider.clientWidth) {
      scrollbar.style.display = 'block';
    } else {
      scrollbar.style.display = 'none';
    }
  }
  
  function startDrag(e) {
    e.preventDefault();
    dragging = true;
    startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    startScroll = slider.scrollLeft;
    slider.style.scrollSnapType = 'none';
    slider.style.scrollBehavior = 'auto';
    document.body.style.userSelect = 'none';
  }
  
  function drag(e) {
    if (!dragging) return;
    e.preventDefault();
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const delta = clientX - startX;
    const ratio = (slider.scrollWidth - slider.clientWidth) / (scrollbar.offsetWidth - thumb.offsetWidth);
    slider.scrollLeft = startScroll + (delta * ratio);
  }
  
  function stopDrag() {
    if (dragging) {
      dragging = false;
      document.body.style.userSelect = '';
      setTimeout(function() {
        slider.style.scrollSnapType = '';
        slider.style.scrollBehavior = '';
      }, 100);
    }
  }
  
  thumb.addEventListener('mousedown', startDrag);
  document.addEventListener('mousemove', drag);
  document.addEventListener('mouseup', stopDrag);
  thumb.addEventListener('touchstart', startDrag, { passive: false });
  document.addEventListener('touchmove', drag, { passive: false });
  document.addEventListener('touchend', stopDrag);
  
  scrollbar.addEventListener('click', function(e) {
    if (e.target === scrollbar) {
      slider.style.scrollSnapType = 'none';
      const percent = (e.clientX - scrollbar.getBoundingClientRect().left) / scrollbar.offsetWidth;
      slider.scrollLeft = percent * (slider.scrollWidth - slider.clientWidth);
      setTimeout(function() { slider.style.scrollSnapType = ''; }, 100);
    }
  });
  
  slider.addEventListener('scroll', update);
  window.addEventListener('resize', update);
  update();
  setTimeout(update, 100);
  setTimeout(update, 500);
  setTimeout(update, 1000);
  
  const images = slider.querySelectorAll('img');
  images.forEach(img => {
    if (img.complete) {
      update();
    } else {
      img.addEventListener('load', update);
    }
  });
}

function cleanupSliders() {
  document.querySelectorAll('[data-slider]').forEach(slider => {
    slider.removeAttribute('data-slider-initialized');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initializeSliders, 100);
});

window.addEventListener('sectionsUpdated', () => {
  cleanupSliders();
  setTimeout(initializeSliders, 100);
});

document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('.product-info form');
  if (productForm) {
    const variantInputs = productForm.querySelectorAll('input[name="id"], select[name="id"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        cleanupSliders();
        setTimeout(initializeSliders, 150);
      });
    });
    
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        cleanupSliders();
        setTimeout(initializeSliders, 150);
      }
    }).observe(document.querySelector('body'), { subtree: true, childList: true });
  }
});